import { TableCells, Invoice } from 'models';
import { styled } from '@material-ui/core';
import { InvoiceLink } from 'components';
import ReceiptIcon from '@material-ui/icons/Receipt';

const InvoiceIcon = styled(ReceiptIcon)({
  display: 'block',
});

export const invoicesTableCells: TableCells<Invoice>[] = [
  {
    id: 'InvoiceId',
    label: '##attribute#invoice#uds_invoicenumber',
    type: 'string',
    render: (invoice) => {
      return `#${invoice.InvoiceId}`;
    },
  },
  {
    id: 'Title',
    label: '##attribute#invoice#name',
    type: 'string',
  },
  {
    id: 'Payers',
    label: '##attribute#invoice#uds_payerpartynames',
    type: 'string',
  },
  {
    id: 'Date',
    label: '##attribute#invoice#uds_invoicedate',
    type: 'date',
    style: { width: '15%', textAlign: 'right' },
    rowStyle: { textAlign: 'right' },
  },
  {
    id: 'PaymentDue',
    label: '##attribute#invoice#uds_paymentduedate',
    type: 'date',
    style: { width: '10%', textAlign: 'right' },
    rowStyle: { textAlign: 'right' },
  },
  {
    id: 'TotalAmountVATIncl.Value',
    label: '#portal.invoice.uds_totalamountvatincluding',
    type: 'string',
    render: (invoice) => {
      return invoice.TotalAmountVATIncl?.Value
        ? `${invoice.TotalAmountVATIncl.Value.toFixed(2)} ${
            invoice.TotalAmountVATIncl?.Symbol
          }`
        : `${invoice.TotalAmountVATIncl?.Value} ${invoice.TotalAmountVATIncl?.Symbol}`;
    },
    style: { textAlign: 'right' },
    rowStyle: { textAlign: 'right' },
    defaultLabelRegister: true,
  },
  {
    id: '_action',
    label: '',
    type: 'string',
    canSort: false,
    render: (invoice) => {
      if (!invoice.DocumentUrl) {
        return null;
      }

      return <InvoiceIcon />;
    },
    style: { width: '5%' },
    rowStyle: { textAlign: 'right' },
  },
];
